import { gql } from '@apollo/client'

import { LANGUAGE_FRAGMENT, METADATA_NODE_FRAGMENT } from '../fragments'

const METADATA_QUERY = gql`
  query metadataQuery {
    mainLocationTypes: locationTypesByIsMain(isMain: true) {
      id
      name
      isCurationEnabled
    }

    additionalLocationTypes: locationTypesByIsMain(isMain: false) {
      id
      name
      isCurationEnabled
    }

    cuisineTypes {
      ...MetadataNodeFragment
    }

    awards {
      ...MetadataNodeFragment
    }

    dishTypes {
      ...MetadataNodeFragment
    }

    courseTypes {
      ...MetadataNodeFragment
    }

    ingredients {
      ...MetadataNodeFragment
    }

    diets {
      id
      name
      isCurationEnabled
    }

    allergens {
      id
      name
      isCurationEnabled
    }

    languages {
      ...LanguageFragment
    }
  }
  ${METADATA_NODE_FRAGMENT}
  ${LANGUAGE_FRAGMENT}
`

export default METADATA_QUERY
